/** Stack categories into fixed vertical columns for the desktop mega-menu. */
export function bucketShopNavColumns(columns, columnCount = 4) {
  if (!columns?.length) return [];
  const count = Math.min(columnCount, columns.length);
  const buckets = Array.from({ length: count }, () => []);
  columns.forEach((col, index) => {
    buckets[index % count].push(col);
  });
  return buckets;
}
